// Grille d'évaluation terrain (plateau + circulation) — Code Deux Roues
// Inspirée de la fiche officielle ECSR : 5 grands domaines × critères observables
// Utilisable en LIVE pendant une séance pour cocher / noter les élèves

export const DOMAINES = [
  {
    key: 'regard',
    label: 'Regard & Anticipation',
    icon: 'Eye',
    color: '#1d4ed8',
    criteres: [
      { id: 'r1', label: 'Regarde loin (horizon, sortie de virage)' },
      { id: 'r2', label: 'Mobilise le regard (balayage, rétroviseurs)' },
      { id: 'r3', label: 'Anticipe les situations (panneaux, trafic)' },
      { id: 'r4', label: 'Évite la fixation sur obstacles' },
      { id: 'r5', label: 'Contrôles visuels avant chaque action' }
    ]
  },
  {
    key: 'posture',
    label: 'Posture & Équilibre',
    icon: 'User',
    color: '#7c3aed',
    criteres: [
      { id: 'p1', label: 'Position stable sur la moto (genoux serrés)' },
      { id: 'p2', label: 'Bras souples, pas crispés' },
      { id: 'p3', label: 'Tête droite, épaules détendues' },
      { id: 'p4', label: 'Pieds bien placés sur les repose-pieds' },
      { id: 'p5', label: 'Transfert de poids cohérent en virage' }
    ]
  },
  {
    key: 'trajectoire',
    label: 'Trajectoire & Placement',
    icon: 'Route',
    color: '#f59e0b',
    criteres: [
      { id: 't1', label: 'Trajectoire extérieur → intérieur → extérieur' },
      { id: 't2', label: 'Placement correct dans la voie' },
      { id: 't3', label: 'Utilise tiers gauche en ville' },
      { id: 't4', label: 'Évite angles morts des autres véhicules' },
      { id: 't5', label: 'Sort du virage en contrôle' }
    ]
  },
  {
    key: 'maitrise',
    label: 'Maîtrise technique',
    icon: 'Settings2',
    color: '#cf2031',
    criteres: [
      { id: 'm1', label: 'Démarrage / arrêt maîtrisés' },
      { id: 'm2', label: 'Freinage progressif et dosé (avant + arrière)' },
      { id: 'm3', label: 'Passage de vitesses fluide' },
      { id: 'm4', label: 'Utilisation correcte de l\'embrayage' },
      { id: 'm5', label: 'Manœuvres à basse vitesse stables' }
    ]
  },
  {
    key: 'securite',
    label: 'Sécurité & Comportement',
    icon: 'ShieldCheck',
    color: '#18794e',
    criteres: [
      { id: 's1', label: 'Respecte distances de sécurité' },
      { id: 's2', label: 'Adapte la vitesse aux conditions' },
      { id: 's3', label: 'Utilise clignotants / signaux correctement' },
      { id: 's4', label: 'Réagit calmement face à l\'imprévu' },
      { id: 's5', label: 'Respecte le Code et les autres usagers' }
    ]
  }
];

// Niveaux d'évaluation (sur chaque critère)
export const NIVEAUX = [
  { value: 'na', label: 'Non observé', color: '#94a3b8', short: '·' },
  { value: 'acquerir', label: 'À acquérir', color: '#b42318', short: 'A' },
  { value: 'encours', label: 'En cours', color: '#f59e0b', short: 'C' },
  { value: 'acquis', label: 'Acquis', color: '#18794e', short: '✓' }
];

// Exercices types terrain
export const EXERCICES = [
  {
    id: 'plateau-lent',
    categorie: 'Plateau',
    nom: 'Parcours à allure réduite',
    duree: '15 min',
    objectif: 'Maîtriser la moto à basse vitesse, équilibre et regard loin.',
    focus: ['regard', 'posture', 'maitrise']
  },
  {
    id: 'plateau-freinage',
    categorie: 'Plateau',
    nom: 'Freinage d\'urgence',
    duree: '15 min',
    objectif: 'Freiner efficacement sans blocage à vitesse stabilisée.',
    focus: ['maitrise', 'securite']
  },
  {
    id: 'plateau-evitement',
    categorie: 'Plateau',
    nom: 'Évitement + freinage',
    duree: '20 min',
    objectif: 'Coordonner évitement et freinage face à l\'imprévu.',
    focus: ['regard', 'trajectoire', 'maitrise']
  },
  {
    id: 'plateau-allure',
    categorie: 'Plateau',
    nom: 'Allure stabilisée (50 km/h)',
    duree: '10 min',
    objectif: 'Tenir une allure régulière et précise.',
    focus: ['maitrise', 'posture']
  },
  {
    id: 'circulation-ville',
    categorie: 'Circulation',
    nom: 'Circulation en ville',
    duree: '30 min',
    objectif: 'Lecture de route, intersections, piétons, angles morts.',
    focus: ['regard', 'trajectoire', 'securite']
  },
  {
    id: 'circulation-route',
    categorie: 'Circulation',
    nom: 'Route ouverte',
    duree: '30 min',
    objectif: 'Dépassements, virages, adaptation vitesse.',
    focus: ['regard', 'trajectoire', 'maitrise']
  },
  {
    id: 'circulation-giratoire',
    categorie: 'Circulation',
    nom: 'Carrefours à sens giratoire (CSG) & intersections',
    duree: '20 min',
    objectif: 'Insertion, placement, sortie maîtrisée.',
    focus: ['regard', 'trajectoire', 'securite']
  },
  {
    id: 'circulation-meteo',
    categorie: 'Circulation',
    nom: 'Conditions dégradées',
    duree: '30 min',
    objectif: 'Adapter vitesse, distances, trajectoires.',
    focus: ['securite', 'maitrise']
  }
];
